import React, { createContext } from "react"
import { IContext, RootState } from "../models/IContext"
import { SeasonIdTemp } from "../models/Season"
import { isLive } from "../models/Utils"
import { Router } from "../utils/Router"
import { ServerCall } from "../utils/ServerCall"
import { SeasonSelector } from "./base/SeasonSelector"
import { UserAvatar } from "./base/UserAvatar"
import { UserCard } from "./base/UserCard"
import { Stagione } from "./main/Stagione"

export const RootContext = createContext<IContext>(null)

export class AppRoot extends React.Component<unknown, RootState>{
    constructor(props: unknown){
        super(props)

        this.state = {
            component: Router.getPage(Router.getBaseUrl() + Router.getWindowUrl().substring(0, Router.getWindowUrl().length - 1)),
            currentLive: null,
            lastLive: null,
            seasons: [],
            loadedUsers: []
        }
    }

    public static loadBoards = (fn: (result: IContext) => void) => ServerCall.get<IContext>("/gld").then(fn)

    componentDidMount = () => {
        window.addEventListener("popstate", this.setFromWindow)

        AppRoot.loadBoards(({ currentLive, lastLive, seasons }) => this.setState({
            currentLive,
            lastLive,
            seasons
        }))
    }

    componentWillUnmount = () => window.removeEventListener("popstate", this.setFromWindow)

    setFromWindow = () => this.setState({ 
        component: Router.getPage(Router.getBaseUrl() + Router.getWindowUrl().substring(0, Router.getWindowUrl().length - 1))
    })

    navigate = (url = Router.getBaseUrl()) => {
        if(Router.polishUrl(url) !== Router.polishUrl(Router.getWindowUrl())){
            const polishUrl = url === Router.getBaseUrl() ? Router.getBaseUrl() : Router.getBaseUrl() + url

            this.setState({ component: Router.getPage(polishUrl) })
            window.history.pushState({}, "", polishUrl)
        }
    }

    render = () => {
        const { component, seasons, currentLive } = this.state,
        tabs = [...seasons]

        if(isLive(currentLive)){
            tabs.splice(0, 0, {
                season_id: SeasonIdTemp.LIVE,
                season_name: "In live ora!"
            })
        }else{
            tabs.splice(0, 0, {
                season_id: SeasonIdTemp.LAST_LIVE,
                season_name: "Ultima live"
            })
        }

        UserAvatar.contextType = RootContext
        UserCard.contextType = RootContext
        Stagione.contextType = RootContext

        return <div className="main">
            <div className="header">
                <a href={Router.getBaseUrl()} rel="noreferrer" className="pkq-logo">
                    <img src={Router.getBaseUrl() + "images/logo_pokequiz.png"} alt="pkquiz-logo" />
                </a>

                <div className="tabs">
                    {
                        tabs.map(s => {
                            const isTemp = s.season_id === SeasonIdTemp.LAST_LIVE || s.season_id === SeasonIdTemp.LIVE,
                            current = Router.isUrl(Router.SEASON_BASE_URL + s.season_id) || (isTemp && Router.isUrl(Router.getBaseUrl())),
                            url = isTemp ? Router.getBaseUrl() : Router.SEASON_BASE_URL + s.season_id

                            return <div className={"tab-pill" + (current ? " selected" : "")} key={s.season_id} onClick={() => this.navigate(url)}>
                                {s.season_name}
                            </div>
                        })
                    }
                </div>

                <SeasonSelector list={tabs} onChange={season => {
                    const isTemp = season.season_id === SeasonIdTemp.LAST_LIVE || season.season_id === SeasonIdTemp.LIVE,
                    url = isTemp ? Router.getBaseUrl() : Router.SEASON_BASE_URL + season.season_id

                    this.navigate(url)
                }} key={JSON.stringify(tabs) + Router.getWindowUrl()} />

                <a href="https://www.pokemonmillennium.net/" rel="noreferrer" className="pm-logo">
                    <img src={Router.getBaseUrl() + "images/logo_pm.svg"} alt="pm-logo" />
                </a>
            </div>
            <div className="px-3 px-xl-5 mx-0 mx-xl-5 mt-3">
                <RootContext.Provider value={{
                    ...this.state,
                    resetCurrentLive: currentLive => this.setState({ currentLive }),
                    addUser: user => {
                        if(!this.state.loadedUsers.find(u => u.login === user.login)){
                            this.setState({
                                loadedUsers: this.state.loadedUsers.concat(user)
                            })
                        }
                    },
                    getUser: username => this.state.loadedUsers.find(u => u.login === username)
                }}>
                    {React.createElement(component, Router.getPathParams() as React.ComponentProps<typeof component>)}
                </RootContext.Provider>
            </div>
        </div>
    }
}